<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <div class="logobox">
        电森活充电
      </div>
      <leftNav></leftNav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <topNav></topNav>
      </el-header>
      <tags-view></tags-view>
      <el-main class="index-main">
        <keep-alive :max="20">
          <router-view :key="routeKey"></router-view>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import topNav from '../components/TopNav.vue'
import leftNav from "../components/Sidebar";
import TagsView from '../components/TagsView.vue';
// 导入组件

export default {
  name: "navcon",
  data() {
    return {
      showclass: 'asideshow',
      showtype: false,
      hasExecuted: false,
    };
  },
  // 注册组件
  components: {
    topNav,
    leftNav,
    TagsView
  },
  computed: {
    routeKey() {
      const counter = this.$store.state.tagsView.refreshCounter[this.$route.path] || 0
      return counter > 0 ? `${this.$route.path}__r${counter}` : this.$route.path
    }
  },
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
  },
  mounted() {

  },
  beforeMount() {
    // if (!this.hasExecuted) {
    //   this.$message({
    //   message: '登录成功',
    //   type: 'success'
    // })
    //     this.hasExecuted = true;
    //   }

  },
};
</script>
<style>
a {
  text-decoration: none !important;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
  margin-left: 5px !important;
  background: #f3f4fd !important;
}

::-webkit-scrollbar-thumb {
  background-color: #bbbbbb !important;
  border-radius: 10px !important;
}
header{
  height: 50px !important;
}
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: #f3f4fd;
}
.el-message-box {
  margin-top: -15% !important;
}
/* 下拉框 */
.el-select-dropdown__wrap {
  border-bottom: none !important;
}
.el-select-dropdown__list {
  padding-bottom: 0 !important;
  border-bottom: none !important;
}
/* 表格和菜单滚动条 */
.el-table__body-wrapper::-webkit-scrollbar,
.el-menu::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
  background-color: #f5f5f5 !important;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-menu::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 你的灰色 */
  border-radius: 4px !important;
}

/* Firefox支持 */
.el-table__body-wrapper, .el-menu {
  scrollbar-width: thin !important;
  scrollbar-color: #c1c1c1 #f5f5f5 !important;
}
/* .el-scrollbar__bar.is-horizontal{
  background: #bbbbbb !important;
} */
.aside {
  width: 64px !important;
  height: 100%;
  background-color: #ffffff;
  margin: 0px;
}
.asideshow {
  width: 202px !important;
  height: 100%;
  background-color: #ffffff;
  border-right: 1px solid rgb(224, 224, 224);
  margin: 0px;
}
.index-header,
.index-main {
  padding: 0px;
  /* border-left: 2px solid #333; */
}
.index-main {
  background: #f3f4fd;
  overflow: auto;
}
.el-table__row:last-child {
  border-bottom: 5px solid blue !important; /* 移除最后一行的底部边框 */
}
.logobox {
  height: 30px;
  line-height: 30px;
  color: #006cff;
  font-size: 22px;
  font-weight: bold;
  background: rgb(255, 255, 255);
  text-align: left;
  padding: 10px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue